exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".margin-bottom-10{margin-bottom:10px}.icon-green{color:#82b73a!important}.icon-red{color:#f1572f!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-7cfe0ae4","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/restaurants/Single.vue
// module id = 283
// module chunks = 0